import styled from 'styled-components';
export const Contanier = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #000;
  width: 93%;
  height: 35vh;
  .copyright {
    color: #fff;
    text-align: center;
    width: 30%;
    margin-left: 2em;
  }
`;
export const CopyRight = styled.p`
  color: #fff;
  text-align: center;
  text-align: center;
  width: 30%;
  font-size: 1.5rem;
  line-height: 1.5;
`;
export const LinkSocial = styled.a`
  color: #fff;
  margin: 0 3rem;
  cursor: pointer;
  font-size: 3rem;
  &:hover {
    color: #4e6e29;
  }
`;
export const FooterContainer = styled.div`
  height: 30vh;
  background: #000;
  margin-top: 10rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const IconsContainer = styled.div`
  margin-bottom: 3rem;
`;
